export enum PregnancyCare {
    NURSERY = "Newborn nursery confinement",
    NICU = "Newborn hospitalized outside of the nursery (NICU)",
    DOULA_CARE = "Doula care"
}